export default "__VITE_ASSET__QTvlSkwe__"